/* eslint-disable consistent-return */
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { getCookies } from '../../hooks/useCookies';
import { SERVER_BASE_URL } from '../../redux/apiConstants';

/**
 * When the user is logged in but has not completed onboarding, redirects them to /onboarding
 * so they cannot access protected routes (dashboard, home, etc.) until onboarding is done.
 * Does nothing when already on /onboarding (allows onboarding flow to render).
 */
// eslint-disable-next-line react/prop-types
function OnboardingGuard({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [allowed, setAllowed] = useState(null);

  useEffect(() => {
    if (location.pathname === '/onboarding') {
      setAllowed(true);
      return;
    }
    const userId = getCookies('USERID');
    const token = getCookies('Token');
    if (!userId || !token) {
      setAllowed(true);
      return;
    }
    let cancelled = false;
    axios
      .get(`${SERVER_BASE_URL}/user/manager/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (cancelled) return;
        const user = response?.data?.data;
        const isOnboarded = user && user.isOnboarded === true;
        if (!isOnboarded) {
          navigate('/onboarding', { replace: true });
          setAllowed(false);
        } else {
          setAllowed(true);
        }
      })
      .catch(() => {
        if (cancelled) return;
        setAllowed(true);
      });
    return () => {
      cancelled = true;
    };
  }, [location.pathname, navigate]);

  if (allowed === false) return null;
  if (allowed === null) return null;
  return children;
}

export default OnboardingGuard;
